import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Stack,
  Button,
  Container,
  Typography,
} from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../components/Button';

// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
// mock
import EditarClienteForm from '../FormsTemplates/Cliente/EditarClienteForms';

export default function EditarCliente() {
  
  return (
    <Page title="Cliente">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Alterar Cliente
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained" color="neutral" component={RouterLink} to="/cliente/consultar" startIcon={<Iconify icon="eva:arrow-back-fill" />}>
              Voltar
            </Button>
          </ThemeProvider>
        </Stack>
        <EditarClienteForm/>    
      </Container>
    </Page>
  );
}
